import React from "react";
import { createRoot } from "react-dom/client";
import App from "../components/auth/sign-up/App";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("auth-sign-up");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <App />
      </>
    );
  }
});
